import OberthurCard from './OberthurCard';

export default OberthurCard;
